var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-link-black';
                    var viewUrl = 'gfx/sprite.svg#view-icon-link-black';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 30 29',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };